export default __webpack_public_path__ + "static/img/promo-icon-2-active.04d91de.png";